import { createSingleton } from '@luna/utils';

import { splitPathFromQueryParams } from './query/QueryParamsService';

type RouterStrategy = {
    /**
     * current pathname + search
     */
    getCurrentRoute(): string;
    setUrl: (url: URL, newPath: string) => URL;
    ensureAbsolutePath: (newPath?: string) => string;
};
const browserRouterStrategy: RouterStrategy = {
    getCurrentRoute(): string {
        if (window.location.search.replace(/^\?/, '')) {
            return `${window.location.pathname}${window.location.search}`;
        }
        return window.location.pathname;
    },
    setUrl: (url, newPath) => {
        const [basePath, baseQueryParams] = splitPathFromQueryParams(newPath);

        url.pathname = basePath;
        url.search = '';
        url.hash = '';

        Object.keys(baseQueryParams).forEach((name) =>
            url.searchParams.set(name, baseQueryParams[name] as string),
        );

        return url;
    },
    ensureAbsolutePath: (newPath) => {
        if (!newPath) {
            return '/';
        }
        if (newPath.startsWith('/')) {
            return newPath;
        }
        return `/${newPath}`;
    },
};
const hashRouterStrategy: RouterStrategy = {
    getCurrentRoute() {
        return window.location.hash;
    },
    setUrl: (url, newPath) => {
        url.hash = newPath;
        return url;
    },
    ensureAbsolutePath: (newPath) => {
        if (!newPath) {
            return newPath as string;
        }
        if (newPath.startsWith('//')) {
            return newPath;
        }
        if (newPath.startsWith('#/')) {
            return newPath;
        }
        if (newPath.startsWith('#')) {
            return newPath.replace('#', '#/');
        }
        if (newPath.startsWith('/')) {
            return `#${newPath}`;
        }
        return `#/${newPath}`;
    },
};
const { get, set } = createSingleton<RouterStrategy>(hashRouterStrategy);

export function setHashRouterStrategy() {
    set(hashRouterStrategy);
}

export function setBrowserRouterStrategy() {
    set(browserRouterStrategy);
}

export const getCurrentRouterStrategy = get;
